import React from 'react';
import { Link } from 'react-router-dom';

function Icon({ children }) {
  return (
    <span className="social-icon" aria-hidden="true">
      {children}
    </span>
  );
}

function Footer() {
  return (
    <footer className="app-footer">
      <div className="footer-col footer-left footer-brand">
        <img src="/logo.png" alt="Logo QueComo" className="footer-logo" onError={(e) => { e.currentTarget.style.display = 'none'; }} />
        <div>
          <strong>QueComo</strong>
          <p>
            <a href="https://qia.com.ar" target="_blank" rel="noreferrer">By QIA</a>
          </p>
        </div>
      </div>

      <div className="footer-col footer-center footer-legal">
        <Link to="/terminos">Términos y Condiciones</Link>
        <Link to="/privacidad">Privacidad y Protección de Datos</Link>
      </div>

      <div className="footer-col footer-right footer-contact" aria-label="Redes y contacto">
        <a href="https://instagram.com/qia.studio" target="_blank" rel="noreferrer" title="Instagram">
          <Icon>
            <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
              <path d="M7 2h10a5 5 0 0 1 5 5v10a5 5 0 0 1-5 5H7a5 5 0 0 1-5-5V7a5 5 0 0 1 5-5Zm5 5.2A4.8 4.8 0 1 0 16.8 12 4.81 4.81 0 0 0 12 7.2Zm0 7.8A3 3 0 1 1 15 12a3 3 0 0 1-3 3Zm5.2-8.4a1.2 1.2 0 1 0 1.2 1.2 1.2 1.2 0 0 0-1.2-1.2Z" />
            </svg>
          </Icon>
        </a>
        <a href="https://facebook.com/qia.studio" target="_blank" rel="noreferrer" title="Facebook">
          <Icon>
            <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
              <path d="M13.5 22v-8h2.7l.4-3h-3.1V9.1c0-.9.3-1.5 1.6-1.5h1.7V4.9c-.3 0-1.3-.1-2.4-.1-2.4 0-4 1.4-4 4.1V11H8v3h2.4v8h3.1Z" />
            </svg>
          </Icon>
        </a>
        <a href="https://tiktok.com/@qia.studio" target="_blank" rel="noreferrer" title="TikTok">
          <Icon>
            <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
              <path d="M14.9 2h2.6c.2 1.5 1.1 2.9 2.5 3.7v2.7a7 7 0 0 1-2.6-.8v7.4a5.6 5.6 0 1 1-5.5-5.6c.3 0 .6 0 .9.1v2.8a2.8 2.8 0 1 0 1.9 2.7V2Z" />
            </svg>
          </Icon>
        </a>
        <a href="https://wa.me/5492352401263" target="_blank" rel="noreferrer" title="WhatsApp">
          <Icon>
            <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
              <path d="M20.5 3.5A10.8 10.8 0 0 0 3.7 17.2L2 22l4.9-1.6a10.8 10.8 0 0 0 5.1 1.3A10.8 10.8 0 0 0 20.5 3.5Zm-8.5 16a8.8 8.8 0 0 1-4.5-1.2l-.3-.2-2.9.9 1-2.8-.2-.3a8.8 8.8 0 1 1 6.9 3.6Zm4.8-6.6c-.3-.2-1.7-.8-2-.9-.3-.1-.5-.2-.7.2l-.6.9c-.2.2-.3.3-.6.1a7.3 7.3 0 0 1-2.1-1.3 8.2 8.2 0 0 1-1.5-1.9c-.2-.3 0-.4.1-.6l.4-.5c.2-.2.3-.4.4-.6.1-.2 0-.4 0-.5l-.9-2.1c-.2-.4-.4-.4-.7-.4h-.6c-.2 0-.5.1-.8.4a3.3 3.3 0 0 0-1 2.5c0 1.5 1.1 2.9 1.2 3.1.2.2 2.2 3.4 5.3 4.7a6.2 6.2 0 0 0 2.1.5 2.9 2.9 0 0 0 2-.9 2.5 2.5 0 0 0 .6-1.7c0-.2-.1-.3-.3-.4Z" />
            </svg>
          </Icon>
        </a>
        <a href="mailto:info@qia.com.ar" title="Email">
          <Icon>
            <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
              <path d="M3 5h18a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1Zm9 7 8-5H4l8 5Zm8 5V9l-8 5-8-5v8h16Z" />
            </svg>
          </Icon>
        </a>
      </div>
    </footer>
  );
}

export default Footer;
